import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Tabs, Tab } from '@mui/material';

export const TabLink = ({ label, to, value, ...rest }) => (
  <Tab label={label} component={Link} value={value} to={to} {...rest} />
);

export const BottomNavTabs = ({ children }) => {
  const { pathname } = useLocation();

  return (
    <Tabs
      sx={(theme) => ({
        width: '100%',
        position: 'fixed',
        bottom: 0,
        left: 0,
        borderTop: `1px solid ${theme.palette.divider}`,
        backgroundColor: '#fafafa',
        zIndex: 2,
      })}
      value={pathname}
      variant="fullWidth"
      indicatorColor="primary"
      textColor="primary"
      id="tabs"
    >
      {children}
    </Tabs>
  );
};
